<template>
  <div id="layout" class="desktop-layout">
    <div id="app-container" class="desktop-container">
      <div id="app">
        <SplashScreen :isLoading="isLoading" />
        <main class="main">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </main>
      </div>
    </div>

    <div v-show="qrCodeVisible" id="qr-ticket">
      <div id="qr-code">
        <div id="qr-title">
          ECCHR Explore is optimized for your mobile device.
        </div>
        <div id="qr-text">
          You can use it on this website, just like you would use a mobile
          application, or you can scan this QR Code with your mobile device to
          experience it on the go:
        </div>
        <div class="qr-code">
          <img id="qr-img" src="./assets/qr-ecchr-metaspher.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SplashScreen from "./views/SplashScreen.vue";

export default {
  name: "App",
  components: {
    SplashScreen,
  },
  data() {
    return { isLoading: true, qrCodeVisible: false };
  },
  computed: {
    ...mapState(["explorationVisible", "episode_id"]),
  },
  mounted() {
    if (window.screen.width < window.screen.height) {
      const layout = document.getElementById("layout");
      layout.classList.remove("desktop-layout");
      this.qrCodeVisible = false;
      this.$store.commit("updateDeviceMode", "mobile");

      let appContainer = document.getElementById("app-container");
      appContainer.classList.remove("desktop-container");
      const app = document.getElementById("app");
      app.classList.add("mobile-app-height");
    } else {
      this.qrCodeVisible = true;
      this.$store.commit("updateDeviceMode", "desktop");
      const app = document.getElementById("app");
      app.classList.add("desktop-app-height");
      const appContainer = document.getElementById("app-container");
      appContainer.classList.add("desktop-container");

      const SplashScreen = document.getElementById("splash-screen");
      SplashScreen.style.display = "block";
      SplashScreen.style.width = "375px";
    }
    setTimeout(() => {
      this.isLoading = false;
    }, 3200);
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.$store.commit("updateExploration", false);
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");

.desktop-layout {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 52%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-areas:
    "app space"
    "app code";
  grid-template-columns: 1fr 490px;
  grid-template-rows: 1fr 1fr;
}

#app {
  position: static;
  font-family: Inter;
  color: whitesmoke;
  overflow-y: scroll;
  background-color: black;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

#app::-webkit-scrollbar {
  display: none;
}

body {
  background-color: rgba(31, 31, 31, 1);
  margin: 0px;
}

#fullscreen-container {
  position: static;
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
  align-content: flex-end;
}

#fullscreen {
  position: absolute;
  bottom: 15px;
}

#fullscreen-icon {
  width: 45px;
  position: relative;
  z-index: 1;
}

#qr-img {
  width: 120px;
}

.desktop-container {
  grid-area: app;
  justify-self: end;
  background-color: rgb(0, 0, 0);
  width: 375px;
  height: 667px;
  overflow: hidden;
  box-shadow: 0px 0px 30px 15px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

#qr-ticket {
  grid-area: code;
  padding-left: 40px;
  align-self: center;
}

#qr-code {
  box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  display: grid;
  padding: 10px;
  background-color: black;
  grid-template-areas:
    "qr-title qr-code"
    "qr-text qr-code";
  grid-template-columns: 0.7fr 0.3fr;
  grid-template-rows: 0.3fr 0.7fr;
}

#qr-title {
  grid-area: qr-title;
  color: white;
  font-family: Inter;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 10px 5px 10px;
}

#qr-text {
  grid-area: qr-text;
  color: rgb(138, 138, 138);
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  padding: 5px 15px 10px 10px;
}

.qr-code {
  grid-area: qr-code;
  justify-self: center;
  align-self: end;
}

.mobile-app-height {
  height: 100vh;
}

.desktop-app-height {
  height: 667px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

span {
  font-weight: 700;
}

.inactive {
  color: rgb(173, 173, 173);
  transition: 0.25s ease-in-out;
}

.eyal-entity {
  color: rgba(187, 119, 55, 1);
}
.fred-entity {
  color: rgba(36, 104, 205, 1);
}
.rabih-entity {
  color: rgba(240, 87, 170, 1);
}
.christina-entity {
  color: rgba(148, 181, 192, 1);
}
.claudia-entity {
  color: rgba(232, 79, 125, 1);
}
.mark-entity {
  color: rgba(127, 105, 191, 1);
}
.priya-entity {
  color: rgba(127, 105, 191, 1);
}
.ixmucane-entity {
  color: rgba(85, 162, 205, 1);
}
.wolfgang-entity {
  color: rgba(3, 149, 169, 1);
}
.karina-entity {
  color: rgba(248, 191, 45, 1);
}

* {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
</style>
